import { render } from "./UserSettingsList.vue?vue&type=template&id=4ff0cd06&scoped=true"
import script from "./UserSettingsList.vue?vue&type=script&lang=ts"
export * from "./UserSettingsList.vue?vue&type=script&lang=ts"

import "./UserSettingsList.vue?vue&type=style&index=0&id=4ff0cd06&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4ff0cd06"

export default script